'use client';
import { ReactNode } from 'react';
import { IntlProvider } from 'react-intl';
interface IntlProviderProps {
  children: ReactNode;
  locale: string;
  messages: Record<string, string>;
}

export function IntlProviderWrapper({ children, locale, messages }: IntlProviderProps) {
  return (
    <IntlProvider messages={messages} locale={locale} defaultLocale="en">
      {children}
    </IntlProvider>
  );
}
